// extracted by mini-css-extract-plugin
module.exports = {"container":"BotLists_container__3IBWJ","botList":"BotLists_botList__2omrZ","title":"BotLists_title__1AD2K"};